import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { Breadcrumbs, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CtBtn from "../Components/CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import CtMultiSelect from "../Components/CustomTool/CtMultiSelect";
import CtART from "./CustomTool/ResponsiveTable";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
} from "../SystemUtility/SystemUtility";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import AMCFollowUpEntry from "./AMCFollowUpEntry";

class AMCFollowUpList extends Component {
  state = {
    ARD: null,
    formData: {
      dtpFromDate: get_30DaysBack_FromCurrentDate(new Date()),
      dtpToDate: get_YMD_from_SYS(new Date()),
      cmbDocumentNos: [],
    },
    documentNoList: [
      { vac_doc_no: "TOP/AMC/BVN/25-26/03" },
      { vac_doc_no: "TOP/AMC/BVN/25-26/04" },
      { vac_doc_no: "TOP/AMC/BVN/25-26/05" },
    ],
    columnsdata: [
      { accessorKey: "paymentFromDate", header: "Payment From Date" },
      { accessorKey: "paymentToDate", header: "Payment To Date" },
      { accessorKey: "regularPrice", header: "Regular Price", align: "right" },
      { accessorKey: "popularPrice", header: "Popular Price", align: "right" },
    ],
    rows: [
      {
        bint_srno: 1,
        paymentFromDate: "2026-01-01",
        paymentToDate: "2026-12-31",
        regularPrice: "1,20,000",
        popularPrice: "1,00,000",
      },
    ],
  };

  componentDidMount() {
    document.title = "AMC Follow Up List";
    localStorage.setItem("Heading", "AMC Follow Up List");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }

  getInfo = () => {
    document.getElementById("dtpFromDate").focus();
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  validateLoadFilters = () => {
    const { dtpFromDate, dtpToDate } = this.state.formData;
    if (!dtpFromDate) {
      this.props.toastErrorMsg("Select From Date", "dtpFromDate");
      return false;
    }
    if (!dtpToDate) {
      this.props.toastErrorMsg("Select To Date", "dtpToDate");
      return false;
    }
    const fromDate = new Date(dtpFromDate);
    const toDate = new Date(dtpToDate);
    if (fromDate > toDate) {
      this.props.toastErrorMsg(
        "From Date should be less than or equal to To Date",
        "dtpFromDate",
      );
      return false;
    }
    return true;
  };

  handleLoad = () => {
    if (!this.validateLoadFilters()) return;
    // TODO: hook up load API when available
  };
  openFollowUPEntryARD = () => {
    this.setState({ ARD: null }, () => {
      const ARD = (
        <AlertResponsiveDialog
          alertHeading={"Follow Up Entry"}
          labelDisagree="Close"
          maxWidthClass={"md"}
          alertMessage={<AMCFollowUpEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };
  render() {
    return (
      <form>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCList">
            AMC List
          </Link>{" "}
          <Link underline="hover" color="inherit" href="#/AMCRegistration">
            AMC Registration
          </Link>
          <Typography sx={{ color: "text.primary" }}>Follow Up List</Typography>
        </Breadcrumbs>

        <Grid container spacing={2} marginTop={2} alignItems={"center"}>
          <Grid item>
            <CtDtp
              id="dtpFromDate"
              label="From Date"
              value={this.state.formData.dtpFromDate}
              handleOnChange={this.handleOnChange}
              width={180}
              nextCtrlID={"dtpToDate"}
              onKeyDown={this.props.onKeyDown}
              maxLength={100}
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpToDate"
              label="To Date"
              value={this.state.formData.dtpToDate}
              handleOnChange={this.handleOnChange}
              width={180}
              nextCtrlID={"cmbDocumentNos"}
              onKeyDown={this.props.onKeyDown}
              maxLength={100}
            />
          </Grid>
          <Grid item>
            <CtMultiSelect
              id="cmbDocumentNos"
              label="Document Number"
              items={this.state.documentNoList}
              colID="vac_doc_no"
              selectedItems={this.state.formData.cmbDocumentNos}
              handleOnChange={this.handleOnChange}
              width={260}
              onKeyDown={this.props.onKeyDown}
              maxLength={100}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Load"
              className="secondary-button"
              onClick={this.handleLoad}
            />
          </Grid>
          {/* <Grid item xs container justifyContent="flex-end">
            <CtBtn
              label="Follow Up Entry"
              className="secondary-button"
              onClick={this.openFollowUPEntryARD}
            />
          </Grid> */}

          <Grid item xs={12} className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={50}
              tblmaxHeight={400}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: () => {},
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: () => {},
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              tableButtonAction={[
                {
                  label: "Follow Up Entry",
                  onClick: this.openFollowUPEntryARD,
                  addPluseIcon: true,
                },
              ]}
              showColumnFilters={false}
              actionColSize={50}
              density={"compact"}
              hideColIdList={[""]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <div style={{ textAlign: "right" }}>{this.state.ARD}</div>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCFollowUpList {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
